import artisticDesktop from './../images/desktop/artistic.png';
import conventionalDesktop from './../images/desktop/conventional.png';
import enterprisingDesktop from './../images/desktop/enterprising.png';
import intellectualDesktop from './../images/desktop/intellectual.png';
import realisticDesktop from './../images/desktop/realistic.png';
import socialDesktop from './../images/desktop/social.png';
import artisticMobile from './../images/mobile/artistic.png';
import conventionalMobile from './../images/mobile/conventional.png';
import enterprisingMobile from './../images/mobile/enterprising.png';
import intellectualMobile from './../images/mobile/intellectual.png';
import realisticMobile from './../images/mobile/realistic.png';
import socialMobile from './../images/mobile/social.png';

export const getCareerGuidanceOptions = () => ({
  realistic: {
    name: 'Реалистичный',
    description: (
      <>
        <p>Люди, у которых выражен реалистический тип личности, предпочитают конкретные задачи, причем чем четче задача сформулирована, тем легче с ней справиться. </p>
        <p>Такие люди ориентируются на настоящее, не любят строить прогнозы и загадывать на будущее, равно как и менять уже сформированную точку зрения;  они крепко стоят на ногах и уверены в себе. Для таких людей разговорный жанр не в почете, результаты их труда осязаемы и предметны.</p>
      </>
    ),
    abilities: 'Физическая сила, психомоторные навыки, ручная ловкость, механические способности, изобретательность, математические способности, практический склад ума.',
    values: 'Эмоциональная стабильность, надежность, практичность, бережливость, упорство, настойчивость, уверенность в себе, целеустремленность, откровенность, искренность, естественность, независимость, консервативность, аккуратность, систематичность.',
    preferences: 'Управление механизмами и использование инструментов, требующих точности, ловкости, тонкой моторной координации (металлорежущие станки, бор дантиста, хирургический скальпель, ювелирные инструменты), строительство, ремонт, военные виды деятельности, конструкторские работы, работа с землёй  и пр.',
    professions: 'Профессии, предполагающие решение конкретных задач: механик, электрик, инженер, моряк, водитель, техник, ювелир, фермер и др. К реалистическому типу часто относятся спортсмены и пилоты.',
    image: {
      mobile: <img style={{ width:'100%' }} src={realisticMobile} alt=''/>,
      desktop: <img style={{ width:'100%' }} src={realisticDesktop} alt=''/>,
    },
    storyImage: {
      me: 'https://84a68b47b1344f5bba45d50d97c8c4b7.storage.msk.3hcloud.com/psychopredict-static/career-guidance/story/realistic_me.png',
      other: 'https://84a68b47b1344f5bba45d50d97c8c4b7.storage.msk.3hcloud.com/psychopredict-static/career-guidance/story/realistic_other.png',
    },
    wallImage: {
      me: 'photo-180721685_457239089',
      other: 'photo-180721685_457239090',
    },
    famousPersons : [
      {
        image: 'https://84a68b47b1344f5bba45d50d97c8c4b7.storage.msk.3hcloud.com/psychopredict-static/career-guidance/icons_for_famous_persons/Screw_and_Shpuntik.png',
        smallImage: 'https://84a68b47b1344f5bba45d50d97c8c4b7.storage.msk.3hcloud.com/psychopredict-static/career-guidance/icons_for_famous_persons/Screw_and_Shpuntik.png',
        name: 'Винтик и Шпунтик',
        subtitle: '«Винтик и Шпунтик»'
      },
      {
        image: 'https://84a68b47b1344f5bba45d50d97c8c4b7.storage.msk.3hcloud.com/psychopredict-static/career-guidance/icons_for_famous_persons/Ant_Man.png',
        smallImage: 'https://84a68b47b1344f5bba45d50d97c8c4b7.storage.msk.3hcloud.com/psychopredict-static/career-guidance/icons_for_famous_persons/Ant_Man.png',
        name: 'Человек-муравей',
        subtitle: '«Marvel»'
      },
      {
        image: 'https://84a68b47b1344f5bba45d50d97c8c4b7.storage.msk.3hcloud.com/psychopredict-static/career-guidance/icons_for_famous_persons/Robinson_Crusoe.png',
        smallImage: 'https://84a68b47b1344f5bba45d50d97c8c4b7.storage.msk.3hcloud.com/psychopredict-static/career-guidance/icons_for_famous_persons/Robinson_Crusoe.png',
        name: 'Робинзон Крузо',
        subtitle: '«Робинзон Крузо»'
      },
      {
        image: 'https://84a68b47b1344f5bba45d50d97c8c4b7.storage.msk.3hcloud.com/psychopredict-static/career-guidance/icons_for_famous_persons/Kopatych.png',
        smallImage: 'https://84a68b47b1344f5bba45d50d97c8c4b7.storage.msk.3hcloud.com/psychopredict-static/career-guidance/icons_for_famous_persons/Kopatych.png',
        name: 'Копатыч',
        subtitle: '«Смешарики»'
      },
      {
        image: 'https://84a68b47b1344f5bba45d50d97c8c4b7.storage.msk.3hcloud.com/psychopredict-static/career-guidance/icons_for_famous_persons/Samwise_Gamgee.png',
        smallImage: 'https://84a68b47b1344f5bba45d50d97c8c4b7.storage.msk.3hcloud.com/psychopredict-static/career-guidance/icons_for_famous_persons/Samwise_Gamgee.png',
        name: 'Сэмуайз Гэмджи',
        subtitle: '«Властелин колец»'
      },
      {
        image: 'https://84a68b47b1344f5bba45d50d97c8c4b7.storage.msk.3hcloud.com/psychopredict-static/career-guidance/icons_for_famous_persons/Terminator.png',
        smallImage: 'https://84a68b47b1344f5bba45d50d97c8c4b7.storage.msk.3hcloud.com/psychopredict-static/career-guidance/icons_for_famous_persons/Terminator.png',
        name: 'Терминатор',
        subtitle: '«Терминатор»'
      },
    ]
  },
  intellectual: {
    name: 'Интеллектуальный',
    description: (
      <>
        <p>Люди, у которых выражен интеллектуальный тип личности,  отличаются независимостью и оригинальностью мышления, умением точно формулировать и излагать свои мысли, решать логические задачи, генерировать новые идеи. Таким людям свойственно любопытство в сочетании с аналитическим складом мышления. </p>
        <p>В работе они внимательны к деталям, причинам и следствиям, причем работа способна увлечь их настолько, что стирается грань между рабочим временем и досугом. Мир идей для них во многих ситуациях важнее, чем общение с людьми.</p>
      </>
    ),
    abilities: 'Математические способности, аналитические навыки, критическое мышление, рациональность, эрудированность.',
    values: 'Независимость, самостоятельность, ориентированность на задачу, погруженность в работу, сдержанность, склонность к рациональному мышлению, методичность, любознательность, интеллектуальность, креативность, эрудированность.',
    preferences: 'Выполнение сложных или абстрактных заданий, научная и исследовательская работа, как теоретическая, так и прикладная, сложные виды деятельности, которые требуют освоения многих фактов, деталей, принципов.',
    style: 'Выясняет множество деталей, прежде чем прийти к заключению, хочет выяснить причины, которые стоят за тем или иным явлением, может слишком сфокусироваться на деталях и не видеть проблему целиком, часто затрудняется высказать свое мнение или принять решение без того, чтобы заново просмотреть информацию.',
    professions: 'Научный работник, автор научно-популярных книг и статей, философ, физик, программист и другие, в деятельности которых необходимы аналитические способности и нестандартное мышление',
    image: {
      mobile: <img style={{ width: '100%' }} src={intellectualMobile} alt=''/>,
      desktop: <img style={{ width:'100%' }} src={intellectualDesktop} alt=''/>,
    },
    storyImage: {
      me: 'https://84a68b47b1344f5bba45d50d97c8c4b7.storage.msk.3hcloud.com/psychopredict-static/career-guidance/story/intellectual_me.png',
      other: 'https://84a68b47b1344f5bba45d50d97c8c4b7.storage.msk.3hcloud.com/psychopredict-static/career-guidance/story/intellectual_other.png',
    },
    wallImage: {
      me: 'photo-180721685_457239092',
      other: 'photo-180721685_457239091',
    },
    famousPersons : [
      {
        image: 'https://84a68b47b1344f5bba45d50d97c8c4b7.storage.msk.3hcloud.com/psychopredict-static/career-guidance/icons_for_famous_persons/Znaika.png',
        smallImage: 'https://84a68b47b1344f5bba45d50d97c8c4b7.storage.msk.3hcloud.com/psychopredict-static/career-guidance/icons_for_famous_persons/Znaika.png',
        name: 'Знайка',
        subtitle: '«Незнайка»'
      },
      {
        image: 'https://84a68b47b1344f5bba45d50d97c8c4b7.storage.msk.3hcloud.com/psychopredict-static/career-guidance/icons_for_famous_persons/Iron_Man.png',
        smallImage: 'https://84a68b47b1344f5bba45d50d97c8c4b7.storage.msk.3hcloud.com/psychopredict-static/career-guidance/icons_for_famous_persons/Iron_Man.png',
        name: 'Железный человек',
        subtitle: '«Marvel»'
      },
      {
        image: 'https://84a68b47b1344f5bba45d50d97c8c4b7.storage.msk.3hcloud.com/psychopredict-static/career-guidance/icons_for_famous_persons/Losyash.png',
        smallImage: 'https://84a68b47b1344f5bba45d50d97c8c4b7.storage.msk.3hcloud.com/psychopredict-static/career-guidance/icons_for_famous_persons/Losyash.png',
        name: 'Лосяш',
        subtitle: '«Смешарики»'
      },
      {
        image: 'https://84a68b47b1344f5bba45d50d97c8c4b7.storage.msk.3hcloud.com/psychopredict-static/career-guidance/icons_for_famous_persons/Jimmy_Neutron.png',
        smallImage: 'https://84a68b47b1344f5bba45d50d97c8c4b7.storage.msk.3hcloud.com/psychopredict-static/career-guidance/icons_for_famous_persons/Jimmy_Neutron.png',
        name: 'Джимми Нейтрон',
        subtitle: '«Джимми Нейтрон»'
      },
      {
        image: 'https://84a68b47b1344f5bba45d50d97c8c4b7.storage.msk.3hcloud.com/psychopredict-static/career-guidance/icons_for_famous_persons/Sheldon_Cooper.png',
        smallImage: 'https://84a68b47b1344f5bba45d50d97c8c4b7.storage.msk.3hcloud.com/psychopredict-static/career-guidance/icons_for_famous_persons/Sheldon_Cooper.png',
        name: 'Шелдон Купер',
        subtitle: '«Теория Большого взрыва»'
      },
      {
        image: 'https://84a68b47b1344f5bba45d50d97c8c4b7.storage.msk.3hcloud.com/psychopredict-static/career-guidance/icons_for_famous_persons/Rick.png',
        smallImage: 'https://84a68b47b1344f5bba45d50d97c8c4b7.storage.msk.3hcloud.com/psychopredict-static/career-guidance/icons_for_famous_persons/Rick.png',
        name: 'Рик',
        subtitle: '«Рик и Морти»'
      },
    ]
  },
  artistic: {
    name: 'Артистический',
    description: (
      <>
        <p>Люди, у которых выражен артистический тип личности, оригинальны, независимы в принятии решений, обладают необычным взглядом на жизнь, гибкостью мышления, эмоциональной чувствительностью, избегают однообразия и физической работы.</p>
        <p>Отношения с людьми строят, опираясь на свои ощущения, эмоции, воображение, интуицию. Они не выносят жесткой регламентации, предпочитая свободный график работы, стремятся к самовыражению.</p>
      </>
    ),
    abilities: 'Воображение, креативность, музыкальные и артистические способности, чувство гармонии, вкуса, внимание к деталям, способность к гибкости и адаптации в меняющихся обстоятельствах, способность ценить и создавать красоту в различных формах.',
    values: 'Независимость, самостоятельность, свой взгляд на жизнь, импульсивность, экспрессивность, эмоциональность, чувствительность, интуитивность, ориентированность на ценности красоты и эстетичности, образность мышления, стремление к самовыражению, демонстративность, коммуникабельность, умение подстроиться под собеседника, оригинальность, открытость, свобода от условностей.',
    preferences: 'Художественное творчество (живопись, скульптура, фотография, создание украшений, дизайн, композиция, литературное творчество и т.п.), игра на музыкальных инструментах, исполнительская, актерская деятельность, деятельность, связанная с красотой, формой, образом и самовыражением.',
    professions: 'Артист, музыкант, скульптор, дирижер, фотограф, учитель музыки, дизайнер, модельер, реставратор, иллюстратор.',   
    image: {
      mobile: <img style={{ width: '100%' }} src={artisticMobile} alt=''/>,
      desktop: <img style={{ width:'100%' }} src={artisticDesktop} alt=''/>,
    },
    storyImage: {
      me: 'https://84a68b47b1344f5bba45d50d97c8c4b7.storage.msk.3hcloud.com/psychopredict-static/career-guidance/story/artistic_me.png',
      other: 'https://84a68b47b1344f5bba45d50d97c8c4b7.storage.msk.3hcloud.com/psychopredict-static/career-guidance/story/artistic_other.png',
    },
    wallImage: {
      me: 'photo-180721685_457239093',
      other: 'photo-180721685_457239094',
    },
    famousPersons : [
      {
        image: 'https://84a68b47b1344f5bba45d50d97c8c4b7.storage.msk.3hcloud.com/psychopredict-static/career-guidance/icons_for_famous_persons/Barash.png',
        smallImage: 'https://84a68b47b1344f5bba45d50d97c8c4b7.storage.msk.3hcloud.com/psychopredict-static/career-guidance/icons_for_famous_persons/Barash.png',
        name: 'Бараш',
        subtitle: '«Смешарики»'
      },
      {
        image: 'https://84a68b47b1344f5bba45d50d97c8c4b7.storage.msk.3hcloud.com/psychopredict-static/career-guidance/icons_for_famous_persons/Alex_Lion.png',
        smallImage: 'https://84a68b47b1344f5bba45d50d97c8c4b7.storage.msk.3hcloud.com/psychopredict-static/career-guidance/icons_for_famous_persons/Alex_Lion.png',
        name: 'Лев Алекс',
        subtitle: '«Мадагаскар»'
      },
      {
        image: 'https://84a68b47b1344f5bba45d50d97c8c4b7.storage.msk.3hcloud.com/psychopredict-static/career-guidance/icons_for_famous_persons/Scarlet_Witch.png',
        smallImage: 'https://84a68b47b1344f5bba45d50d97c8c4b7.storage.msk.3hcloud.com/psychopredict-static/career-guidance/icons_for_famous_persons/Scarlet_Witch.png',
        name: 'Алая Ведьма',
        subtitle: '«Marvel»'
      },
      {
        image: 'https://84a68b47b1344f5bba45d50d97c8c4b7.storage.msk.3hcloud.com/psychopredict-static/career-guidance/icons_for_famous_persons/Gin.png',
        smallImage: 'https://84a68b47b1344f5bba45d50d97c8c4b7.storage.msk.3hcloud.com/psychopredict-static/career-guidance/icons_for_famous_persons/Gin.png',
        name: 'Джинн',
        subtitle: '«Алладин»'
      },
      {
        image: 'https://84a68b47b1344f5bba45d50d97c8c4b7.storage.msk.3hcloud.com/psychopredict-static/career-guidance/icons_for_famous_persons/Gollum.png',
        smallImage: 'https://84a68b47b1344f5bba45d50d97c8c4b7.storage.msk.3hcloud.com/psychopredict-static/career-guidance/icons_for_famous_persons/Gollum.png',
        name: 'Горлум',
        subtitle: '«Властелин колец»'
      },
      {
        image: 'https://84a68b47b1344f5bba45d50d97c8c4b7.storage.msk.3hcloud.com/psychopredict-static/career-guidance/icons_for_famous_persons/Joker.png',
        smallImage: 'https://84a68b47b1344f5bba45d50d97c8c4b7.storage.msk.3hcloud.com/psychopredict-static/career-guidance/icons_for_famous_persons/Joker.png',
        name: 'Джокер',
        subtitle: '«Тёмный рыцарь»'
      },
    ]
  },
  social: {
    name: 'Социальный',
    description: (
      <>
        <p>Люди, у которых выражен социальный тип личности, стремятся к тем видам деятельности, которые реализуют навыки в области человеческих отношений. Это обучение, просвещение, лечение, воспитание, консультирование.</p>
        <p>Для таких людей социальные взаимодействия играют важнейшую роль, они тактичны, убедительны и готовы к сотрудничеству и сопереживанию. Любят работать в группах для достижения общих целей.</p>
      </>
    ),
    abilities: 'Вербальные способности (использование языка, речи, как средства оформления мыслей), преподавательские, ораторские способности, навыки общения и взаимодействия с людьми, навыки слушания.',
    values: 'Нуждаются в активных социальных контактах, стремятся поучать, воспитывать, настроенность на других, понимание других, терпеливость, сострадательность, тактичные, эмоционально теплые, дружеские, жизнерадостные, оптимистичные.',
    preferences: 'Ориентация на работу в группе с людьми, а не с предметами, обучение, объяснение, разъяснение, оказание помощи, консультирование, советы и рекомендации, организация групповых мероприятий, ведение дискуссий.',
    professions: 'Врач, учитель, психолог, социальный работник, менеджер по персоналу, организатор мероприятий, представитель службы поддержки клиентов и др.',
    image: {
      mobile: <img style={{ width: '100%' }} src={socialMobile} alt=''/>,
      desktop: <img style={{ width:'100%' }} src={socialDesktop} alt=''/>
    },
    storyImage: {
      me: 'https://84a68b47b1344f5bba45d50d97c8c4b7.storage.msk.3hcloud.com/psychopredict-static/career-guidance/story/social_me.png',
      other: 'https://84a68b47b1344f5bba45d50d97c8c4b7.storage.msk.3hcloud.com/psychopredict-static/career-guidance/story/social_other.png',
    },
    wallImage: {
      me: 'photo-180721685_457239095',
      other: 'photo-180721685_457239088',
    },
    famousPersons : [
      {
        image: 'https://84a68b47b1344f5bba45d50d97c8c4b7.storage.msk.3hcloud.com/psychopredict-static/career-guidance/icons_for_famous_persons/Mother_Teresa.png',
        smallImage: 'https://84a68b47b1344f5bba45d50d97c8c4b7.storage.msk.3hcloud.com/psychopredict-static/career-guidance/icons_for_famous_persons/Mother_Teresa.png',
        name: 'Мать Тереза',
        subtitle: '«Монахиня»'
      },
      {
        image: 'https://84a68b47b1344f5bba45d50d97c8c4b7.storage.msk.3hcloud.com/psychopredict-static/career-guidance/icons_for_famous_persons/Professor_X.png',
        smallImage: 'https://84a68b47b1344f5bba45d50d97c8c4b7.storage.msk.3hcloud.com/psychopredict-static/career-guidance/icons_for_famous_persons/Professor_X.png',
        name: 'Профессор Икс',
        subtitle: '«Marvel»'
      },
      {
        image: 'https://84a68b47b1344f5bba45d50d97c8c4b7.storage.msk.3hcloud.com/psychopredict-static/career-guidance/icons_for_famous_persons/Leopold_Cat.png',
        smallImage: 'https://84a68b47b1344f5bba45d50d97c8c4b7.storage.msk.3hcloud.com/psychopredict-static/career-guidance/icons_for_famous_persons/Leopold_Cat.png',
        name: 'Кот Леопольд',
        subtitle: '«Кот Леопольд»'
      },
      {
        image: 'https://84a68b47b1344f5bba45d50d97c8c4b7.storage.msk.3hcloud.com/psychopredict-static/career-guidance/icons_for_famous_persons/Marty_Zebra.png',
        smallImage: 'https://84a68b47b1344f5bba45d50d97c8c4b7.storage.msk.3hcloud.com/psychopredict-static/career-guidance/icons_for_famous_persons/Marty_Zebra.png',
        name: 'Зебра Марти',
        subtitle: '«Мадагаскар»'
      },
      {
        image: 'https://84a68b47b1344f5bba45d50d97c8c4b7.storage.msk.3hcloud.com/psychopredict-static/career-guidance/icons_for_famous_persons/Sovuya.png',
        smallImage: 'https://84a68b47b1344f5bba45d50d97c8c4b7.storage.msk.3hcloud.com/psychopredict-static/career-guidance/icons_for_famous_persons/Sovuya.png',
        name: 'Совунья',
        subtitle: '«Смешарики»'
      },
      {
        image: 'https://84a68b47b1344f5bba45d50d97c8c4b7.storage.msk.3hcloud.com/psychopredict-static/career-guidance/icons_for_famous_persons/Anna.png',
        smallImage: 'https://84a68b47b1344f5bba45d50d97c8c4b7.storage.msk.3hcloud.com/psychopredict-static/career-guidance/icons_for_famous_persons/Anna.png',
        name: 'Анна',
        subtitle: '«Холодное сердце»'
      },
    ]
  },
  enterprising: {
    name: 'Предприимчивый',
    description: (
      <>
        <p>Люди, у которых выражен предпринимательский тип личности, как правило, являются прирожденными лидерами. Им нравится брать на себя ответственность и добиваться успеха. Заинтересованы в тех сферах деятельности, где можно проявить организаторские способности для достижения экономических или политических целей.</p>
        <p>Для этого они могут проявить свой энтузиазм, импульсивность, энергичность и креативное мышление, избегая при этом исследовательских или научных занятий.  Один из тех типов личности, которые с легкостью работают в ситуации неопределенности и риска.</p>
      </>
    ),
    abilities: 'Cтратегическое мышление, организаторские способности, ораторские способности, способность убеждения, склонность к предпринимательской деятельности.',
    values: 'Лидерство, амбициозность, азартность, склонность к риску, соревновательность, самоуверенность, авантюристичность, коммуникабельность, ориентированность на деньги, власть, материальное благополучие, оптимистичность, энергичность, любовь к популярности.',
    preferences: 'Работа с другими людьми в организациях для достижения организационных целей и экономического успеха, соревновательные виды деятельности, продажа, покупка, коммерция, предпринимательство, проведение собраний, руководство организациями, компаниями, управление людьми и проектами, проведение политических кампаний, предпочтительная профессиональная сфера – менеджмент, юриспруденция, политика и общественная деятельность.',    
    professions: 'Предприниматель, адвокат, страховой агент, брокер на бирже, агент по недвижимости, политик, пиарщик, бизнес-консультант, инвестор.',
    image: {
      mobile: <img style={{ width: '100%' }} src={enterprisingMobile} alt=''/>,
      desktop: <img style={{ width:'100%' }} src={enterprisingDesktop} alt=''/>,
    },
    storyImage: {
      me: 'https://84a68b47b1344f5bba45d50d97c8c4b7.storage.msk.3hcloud.com/psychopredict-static/career-guidance/story/enterprising_me.png',
      other: 'https://84a68b47b1344f5bba45d50d97c8c4b7.storage.msk.3hcloud.com/psychopredict-static/career-guidance/story/enterprising_other.png',
    },
    wallImage: {
      me: 'photo-180721685_457239095',
      other: 'photo-180721685_457239088',
    },
    famousPersons : [
      {
        image: 'https://84a68b47b1344f5bba45d50d97c8c4b7.storage.msk.3hcloud.com/psychopredict-static/career-guidance/icons_for_famous_persons/Ostap_Bender.png',
        smallImage: 'https://84a68b47b1344f5bba45d50d97c8c4b7.storage.msk.3hcloud.com/psychopredict-static/career-guidance/icons_for_famous_persons/Ostap_Bender.png',
        name: 'Остап Бендер',
        subtitle: '«Двенадцать стульев»'
      },
      {
        image: 'https://84a68b47b1344f5bba45d50d97c8c4b7.storage.msk.3hcloud.com/psychopredict-static/career-guidance/icons_for_famous_persons/Eugene_Krabs.png',
        smallImage: 'https://84a68b47b1344f5bba45d50d97c8c4b7.storage.msk.3hcloud.com/psychopredict-static/career-guidance/icons_for_famous_persons/Eugene_Krabs.png',
        name: 'Юджин Крабс',
        subtitle: '«Губка Боб»'
      },
      {
        image: 'https://84a68b47b1344f5bba45d50d97c8c4b7.storage.msk.3hcloud.com/psychopredict-static/career-guidance/icons_for_famous_persons/James_Bond.png',
        smallImage: 'https://84a68b47b1344f5bba45d50d97c8c4b7.storage.msk.3hcloud.com/psychopredict-static/career-guidance/icons_for_famous_persons/James_Bond.png',
        name: 'Джеймс Бонд',
        subtitle: '«Агент 007»'
      },
      {
        image: 'https://84a68b47b1344f5bba45d50d97c8c4b7.storage.msk.3hcloud.com/psychopredict-static/career-guidance/icons_for_famous_persons/Nick_Fury.png',
        smallImage: 'https://84a68b47b1344f5bba45d50d97c8c4b7.storage.msk.3hcloud.com/psychopredict-static/career-guidance/icons_for_famous_persons/Nick_Fury.png',
        name: 'Ник Фьюрри',
        subtitle: '«Marvel»'
      },
      {
        image: 'https://84a68b47b1344f5bba45d50d97c8c4b7.storage.msk.3hcloud.com/psychopredict-static/career-guidance/icons_for_famous_persons/Krosh.png',
        smallImage: 'https://84a68b47b1344f5bba45d50d97c8c4b7.storage.msk.3hcloud.com/psychopredict-static/career-guidance/icons_for_famous_persons/Krosh.png',
        name: 'Крош',
        subtitle: '«Смешарики»'
      },
      {
        image: 'https://84a68b47b1344f5bba45d50d97c8c4b7.storage.msk.3hcloud.com/psychopredict-static/career-guidance/icons_for_famous_persons/Neo.png',
        smallImage: 'https://84a68b47b1344f5bba45d50d97c8c4b7.storage.msk.3hcloud.com/psychopredict-static/career-guidance/icons_for_famous_persons/Neo.png',
        name: 'Нео',
        subtitle: '«Матрица»'
      },
    ]
  },
  conventional: {
    name: 'Конвенциональный',
    description: (<>
      <p>Люди, у которых выражен конвенциональный тип личности, стремятся к деятельности, предполагающей работу с информацией, ее сбор, хранение, систематизацию, являются превосходными исполнителями.</p>
      <p>Для них ценны эффективность, методичность, деловые и экономические достижения. При этом такие люди консервативны, не любят ситуации непредсказуемости и неопределенности, предпочитают знать, что от них ожидают.</p>
    </>),
    abilities: 'Внимательность к деталям, способность структурировать информацию, навыки работы с числами, канцелярские способности, ручная тонкая моторика, умение организовывать свою работу и расставить приоритеты, умение следовать инструкциям.',
    values: 'Организованность, пунктуальность, педантичность, аккуратность, сознательность, упорство, практичность, самоконтроль, консервативность',
    preferences: 'Работа, которая требует внимания к деталям и аккуратности, ведение картотек, хранение и систематизация записей, фактов, данных, финансовых книг, написание деловых отчетов, подготовка схем, таблиц, диаграмм, работа в  корпорациях, финансовых организациях, архивах, инспекциях, офисное администрирование.',
    professions: 'Cекретарь, патентовед, нотариус, топограф, корректор, страховой агент, офис-менеджер, бухгалтер, аудитор.',
    image: {
      mobile: <img style={{ width:'100%' }} src={conventionalMobile} alt=''/>,
      desktop: <img style={{ width:'100%' }} src={conventionalDesktop} alt=''/>,
    },
    storyImage: {
      me: 'https://84a68b47b1344f5bba45d50d97c8c4b7.storage.msk.3hcloud.com/psychopredict-static/career-guidance/story/conventional_me.png',
      other: 'https://84a68b47b1344f5bba45d50d97c8c4b7.storage.msk.3hcloud.com/psychopredict-static/career-guidance/story/conventional_other.png',
    },
    wallImage: {
      me: 'https://84a68b47b1344f5bba45d50d97c8c4b7.storage.msk.3hcloud.com/psychopredict-static/career-guidance/story/realistic_me.png',
      other: 'https://84a68b47b1344f5bba45d50d97c8c4b7.storage.msk.3hcloud.com/psychopredict-static/career-guidance/story/realistic_me.png',
    },
    famousPersons : [
      {
        image: 'https://84a68b47b1344f5bba45d50d97c8c4b7.storage.msk.3hcloud.com/psychopredict-static/career-guidance/icons_for_famous_persons/Squidward.png',
        smallImage: 'https://84a68b47b1344f5bba45d50d97c8c4b7.storage.msk.3hcloud.com/psychopredict-static/career-guidance/icons_for_famous_persons/Squidward.png',
        name: 'Сквидвард',
        subtitle: '«Спанч Боб»'
      },
      {
        image: 'https://84a68b47b1344f5bba45d50d97c8c4b7.storage.msk.3hcloud.com/psychopredict-static/career-guidance/icons_for_famous_persons/Malvina.png',
        smallImage: 'https://84a68b47b1344f5bba45d50d97c8c4b7.storage.msk.3hcloud.com/psychopredict-static/career-guidance/icons_for_famous_persons/Malvina.png',
        name: 'Мальвина',
        subtitle: '«Буратино»'
      },
      {
        image: 'https://84a68b47b1344f5bba45d50d97c8c4b7.storage.msk.3hcloud.com/psychopredict-static/career-guidance/icons_for_famous_persons/Melman_Giraffe.png',
        smallImage: 'https://84a68b47b1344f5bba45d50d97c8c4b7.storage.msk.3hcloud.com/psychopredict-static/career-guidance/icons_for_famous_persons/Melman_Giraffe.png',
        name: 'Жираф Мелман',
        subtitle: '«Мадагаскар»'
      },
      {
        image: 'https://84a68b47b1344f5bba45d50d97c8c4b7.storage.msk.3hcloud.com/psychopredict-static/career-guidance/icons_for_famous_persons/Morty.png',
        smallImage: 'https://84a68b47b1344f5bba45d50d97c8c4b7.storage.msk.3hcloud.com/psychopredict-static/career-guidance/icons_for_famous_persons/Morty.png',
        name: 'Морти',
        subtitle: '«Рик и Морти»'
      },
      {
        image: 'https://84a68b47b1344f5bba45d50d97c8c4b7.storage.msk.3hcloud.com/psychopredict-static/career-guidance/icons_for_famous_persons/Yezhik.png',
        smallImage: 'https://84a68b47b1344f5bba45d50d97c8c4b7.storage.msk.3hcloud.com/psychopredict-static/career-guidance/icons_for_famous_persons/Yezhik.png',
        name: 'Ёжик',
        subtitle: '«Смешарики»'
      },
      {
        image: 'https://84a68b47b1344f5bba45d50d97c8c4b7.storage.msk.3hcloud.com/psychopredict-static/career-guidance/icons_for_famous_persons/Wally.png',
        smallImage: 'https://84a68b47b1344f5bba45d50d97c8c4b7.storage.msk.3hcloud.com/psychopredict-static/career-guidance/icons_for_famous_persons/Wally.png',
        name: 'Валли',
        subtitle: '«ВАЛЛ-И»'
      },
    ]
  },
});

export const storyTemplate = {
  story_box: {
    background_type: 'image',
    url: '',  // Место для картинки в сторис
    attachment: {
      text: 'open',
      type: 'url',
      url: 'https://vk.com/vk_temperament'
    },
  },
  successfulMyEvent: { type: 'story',  name: 'successfully_uploaded_my_results_in_story' },
  successfulOtherEvent: { type: 'story',  name: 'successfully_uploaded_other_results_in_story' },
  failedMyEvent: { type: 'story', name: 'failed_to_upload_my_results_in_story' },
  failedOtherEvent: { type: 'story', name: 'failed_to_upload_other_results_in_story' },
};

export const USER_DENIED_ERROR_MESSAGE = 'User denied';
